import { useParams } from 'react-router-dom';
import Layout from '../components/Layout';
import BusinessPortfolioManager from '../components/BusinessPortfolioManager';

export default function OrganizationProfileDetail() {
  const { userId } = useParams();

  return (
    <Layout searchPlaceholder="Search profile records...">
      <div className="space-y-8">
        <section className="space-y-2">
          <span className="text-xs font-bold uppercase tracking-[0.22em] text-[#f1c100]">
            Business Manager
          </span>
          <h1 className="font-['Geist'] text-[clamp(2rem,5vw,3rem)] font-black tracking-[-0.03em] text-white">
            Profile Command Sheet
          </h1>
          <p className="max-w-3xl text-[#d2c5ab]">
            This detail workspace keeps the editing, support pings, and connected portal review off the overview screen so the main business monitor stays clean.
          </p>
        </section>

        <BusinessPortfolioManager userId={userId} />
      </div>
    </Layout>
  );
}
